import React, { Component } from "react";
import { connect } from "react-redux";
import backlogo from "../../assets/images/svg/Back.svg";
import { Link } from "react-router-dom";
import Loader from "react-loaders";
import CytoscapeGraph from "./CytoscapeGraph";
import axiosInstance from "../configuration/Request";
import { ToastContainer } from "react-toastify";
import { showErrorToast } from "../Components/Toaster";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class ViewNetwork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGene: null,
      loader: false,
      nodeData: {},
      geneConnectionData: [],
      graphKey: Date.now(),
      showLegend: false,
      showNetworkParams: false,
      network_type: "",
      networkInformation: {},
      dataType: "Default",

    };
  }

  handleGeneSelection = (gene) => {
    this.setState({
      selectedGene: gene?.clickedNodeData,
      geneConnectionData: gene?.connectedEdgesData,
    });
  };

  componentDidMount() {
    this.fetchCytoscapeDetails();
  }

  fetchCytoscapeDetails = () => {
    this.setState({ loader: true });
    const { cytoscapeID, isFromProject } = this.props.reduxData.cytoscapeData;
    const apiUrl = isFromProject
      ? `${process.env.REACT_APP_BASE_URL}api/gene-lists/cytoscape-data?id=${cytoscapeID}`
      : `${process.env.REACT_APP_BASE_URL}api/network-cytoscape?id=${cytoscapeID}`;

    axiosInstance
      .get(apiUrl)
      .then((res) => {
        const data = isFromProject ? res?.data : res?.data?.data || {};

        this.setState({
          nodeData: this.extractNodeData(data),
          network_type: data?.network_type || (isFromProject ? "Project" : ""),
          dataType: data?.data_type || (data?.network_type === "Created" ? null : "Different"),
          networkInformation: this.extractNetworkInformation(data),
        });
      })
      .catch((err) => {
        showErrorToast(
          err?.response?.data?.error?.message || "Error while fetching network",
          false
        );
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  // Extract node and edge data
  extractNodeData = (data) => ({
    nodes: data?.cytoscape?.nodes || [],
    edges: data?.cytoscape?.edges || [],
  });

  extractNetworkInformation = (data) => ({
    id: data.id,
    p_value: data?.p_value || "NA",
    scope: data?.scope || "NA",
    precision: data?.precision || "NA",
    cancer_type: data?.cancer_type || "NA",
    subsampling_yes_no: data?.subsampling_yes_no || "NA",
    data_source: data?.data_source || "NA",
    histological_subtype: data?.histological_subtype || "NA",
    normal_tumor: data?.normal_tumor || "NA",
    sample_type: data?.sample_type || "NA",
    risk_level: data?.risk_level || "NA",
    project_name: data?.project_name || "NA",
    source_gene_name: data?.source_gene_name || "NA",
    target_gene_name: data?.target_gene_name || "NA",
    therapeutic_response: data?.therapeutic_response || "NA",
    operation_type: data?.operation_type || "NA",
    network_1: data?.network_file_1?.[0]?.project_name || "NA",
    network_2: data?.network_file_2?.[0]?.project_name || "NA",
  });

  handleGraphReset = () => {
    this.setState({ graphKey: Date.now() });
  };

  toggleLegend = () => {
    this.setState((prevState) => ({ showLegend: !prevState.showLegend }));
  };

  toggleNetworkParams = () => {
    this.setState((prevState) => ({
      showNetworkParams: !prevState.showNetworkParams,
    }));
  };

  render() {
    return (
      <div className="network-view-top">
        <ToastContainer />

        <div className="network-view-left mt-2">
          <div className="card card-cancerType">
            <div className="view-network-container">
              <Link
                className="btn-link-primary"
                to={{ pathname: "/app/discover/myProject", search: `?activeTab=${new URLSearchParams(this.props.location.search).get('activeTab') || 'networks'}` }}
              >
                <div className="d-inline-flex">
                  <img src={backlogo} alt="" />
                  <span
                    style={{ color: "#333333", fontWeight: 400 }}
                    className="ms-1"
                  >
                    Back
                  </span>
                </div>
              </Link>
            </div>

            <div className="network-view-left-inside">
              <div className="network-view-top-container">
                <div className="title-div fw-bold d-flex align-items-center">
                  Parameters of this Network
                </div>
                <div className="pt-1">
                  {this.state?.networkInformation?.p_value && (
                    <div className="mb-2">
                      Significances Level:
                      <span className="fw-bold">
                        &nbsp;{this.state?.networkInformation?.p_value}
                      </span>
                    </div>
                  )}

                  {this.state?.networkInformation?.precision && (
                    <div className="mb-2">
                      Precision Threshold:
                      <span className="fw-bold">
                        &nbsp;{this.state?.networkInformation?.precision}
                      </span>
                    </div>
                  )}
                  {this.state?.networkInformation?.scope && (
                    <div className="mb-2">
                      Scope Threshold:
                      <span className="fw-bold">
                        &nbsp;{this.state?.networkInformation?.scope}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {/* Network Parameters Collapsible Section */}
              <div className="legend-container mt-3">
                <div>
                  <div
                    className="legend-top fw-bold"
                    onClick={this.toggleNetworkParams}
                  >
                    <span> Network Information </span>
                    <span className="ms-2">
                      {this.state.showNetworkParams ? (
                        <FaAngleUp size={18} />
                      ) : (
                        <FaAngleDown size={18} />
                      )}
                    </span>
                  </div>
                  {this.state.showNetworkParams &&
                    (this.state.network_type === "Operation" ? (
                      <ul className="mt-2">
                        <li>
                          <span className="fw-bold">
                            Operation Type :&nbsp;
                          </span>
                          {this.state.networkInformation.operation_type}
                        </li>
                        <div className="project-name-outer ">
                          <span className="fw-bold">Network_1 :</span>
                          <span>
                            {" "}
                            {this.state.networkInformation.network_1}
                          </span>
                        </div>
                        <div className="project-name-outer ">
                          <span className="fw-bold">Network_2 :</span>
                          <span>
                            {" "}
                            {this.state.networkInformation.network_2}
                          </span>
                        </div>
                      </ul>
                    ) : (
                      <ul className="mt-2">
                        <li>
                          <span className="fw-bold">Cancer Type :&nbsp;</span>
                          {this.state.networkInformation.cancer_type}
                        </li>
                        <li>
                          <span className="fw-bold">
                            Bootstrap Yes/No :&nbsp;
                          </span>
                          {this.state.networkInformation.subsampling_yes_no}
                        </li>
                        <li>
                          <span className="fw-bold">Data Source :&nbsp;</span>
                          {this.state.networkInformation.data_source}
                        </li>
                        <li>
                          <span className="fw-bold">
                            Histological Subtype :&nbsp;
                          </span>{" "}
                          {this.state.networkInformation.histological_subtype}
                        </li>
                        <li>
                          <span className="fw-bold">Normal or Tumor :&nbsp;</span>
                          {this.state.networkInformation.normal_tumor}
                        </li>
                        <li>
                          <span className="fw-bold">Sample Type :&nbsp;</span>
                          {this.state.networkInformation.sample_type}
                        </li>
                        <li>
                          <span className="fw-bold">Risk Level :&nbsp;</span>
                          {this.state.networkInformation.risk_level}
                        </li>
                        <div className="project-name-outer ">
                          <span className="fw-bold">Project Name :</span>
                          <span>
                            {" "}
                            {this.state.networkInformation.project_name}
                          </span>
                        </div>
                        <li>
                          <span className="fw-bold">
                            Source Gene Type :&nbsp;
                          </span>
                          {this.state.networkInformation.source_gene_name}
                        </li>
                        <li>
                          <span className="fw-bold">
                            Target Gene Type :&nbsp;
                          </span>
                          {this.state.networkInformation.target_gene_name}
                        </li>
                        <li>
                          <span className="fw-bold">
                            Therapeutic Response :&nbsp;
                          </span>
                          {this.state.networkInformation.therapeutic_response}
                        </li>
                      </ul>
                    ))}
                </div>
              </div>
              <div className="legend-container mt-2">
                <div>
                  <div className="legend-top fw-bold">
                    <span onClick={this.toggleLegend}>
                      {" "}
                      Nodes Representation
                    </span>
                    <span className=" ms-2" onClick={this.toggleLegend}>
                      {" "}
                      <IoIosInformationCircleOutline size={18} />{" "}
                    </span>
                  </div>
                  {this.state.showLegend && (
                    <ul className="mt-2">
                      <li>
                        <div className="shape-outer">
                          <span className="legend-shape triangle"></span>
                        </div>{" "}
                        CNV
                      </li>
                      <li>
                        <div className="shape-outer">
                          <span className="legend-shape ellipse"></span>
                        </div>{" "}
                        mRNA
                      </li>
                      <li>
                        <div className="shape-outer">
                          <span className="legend-shape rectangle"></span>{" "}
                        </div>{" "}
                        Protein
                      </li>
                      <li>
                        <div className="shape-outer">
                          {" "}
                          <span className="legend-shape diamond"></span>
                        </div>{" "}
                        Mutation
                      </li>
                      <li>
                        <div className="shape-outer">
                          <span className="legend-shape hexagon"></span>
                        </div>{" "}
                        Fusion
                      </li>
                      <li>
                        <div className="shape-outer">
                          <span className="legend-shape octagon"></span>
                        </div>{" "}
                        Methylation
                      </li>
                      <li>
                        {/* <div className="shape-outer">
                          <span className="legend-shape pentagon"></span>
                        </div>{" "}
                        Molecular Entity <br></br> (encompassing above molecular features) */}
                        <div className="legend-item">
                          <div className="legend-row">
                            <span className="legend-shape pentagon"></span>
                            <span className="legend-text">
                              Molecular Entity
                            </span>
                          </div>
                          <div className="legend-description">
                            (encompassing above molecular features)
                          </div>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </div>

              {this.state?.selectedGene && (
                <div className="gene-details-container mt-2">
                  <div className="fw-bold">
                    {this.state?.selectedGene?.name}
                  </div>
                  <div className="table-container">
                    {this.state.geneConnectionData.length > 0 ? (
                      (() => {
                        // Check if at least one row has a non-empty rule_description
                        const shouldShowDescription = this.state.dataType !== "Different" &&
                          this.state.geneConnectionData.some(
                            (row) => row.rule_description && row.rule_description.trim() !== ""
                          );

                        return (
                          <table className="view-table">
                            <thead>
                              <tr>
                                <th class="view-th" style={{ width: "20%" }}>Source</th>
                                <th class="view-th" style={{ width: "20%" }}>Target</th>
                                {shouldShowDescription && (
                                  <th class="view-th" style={{ width: "60%" }}>Description</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.geneConnectionData.map(
                                (row, index) => (
                                  <tr key={index}>
                                    <td class="view-td">{row?.source?.split("_")[0]}</td>
                                    <td class="view-td">{row?.target?.split("_")[0]}</td>
                                    {shouldShowDescription && (
                                      <td class="view-td">{row.rule_description}</td>
                                    )}
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        );
                      })()
                    ) : (
                      <div>No data found</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="network-view-right mt-2">
          <div
            className="card section-container-view"
            style={{ padding: "16px" }}
          >
            {this.state.nodeData?.nodes?.length > 0 ? (
              <CytoscapeGraph
                key={this.state.graphKey}
                nodeDetails={this.state.nodeData}
                onGeneClick={this.handleGeneSelection}
                onResetClick={this.handleGraphReset}
                dataType={this.state.dataType}
                networkInformation={this.state.networkInformation}
              />
            ) : (
              <div
                className="text-center fw-bold d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                Network not Found
              </div>
            )}
          </div>
        </div>

        {this.state.loader && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(ViewNetwork);